import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=099dc11c&scoped=true"
import script from "./WidgetList.vue?vue&type=script&lang=js"
export * from "./WidgetList.vue?vue&type=script&lang=js"
import style0 from "./WidgetList.vue?vue&type=style&index=0&id=099dc11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099dc11c",
  null
  
)

export default component.exports